import React, { useState, useRef, useEffect } from "react";
import "./SearchableList.css"; // Import the CSS file
import { Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";

// Function to generate a large dataset
const generateData = (numItems) => {
  const regions = ["EMEA", "NA", "ASIA", "LATAM"];
  const modelCodes = ["19MV", "19DV", "19XR", "23XR", "21DV", "21MV"];
  const data = [];

  for (let i = 0; i < numItems; i++) {
    const modelCode = `${
      modelCodes[Math.floor(Math.random() * modelCodes.length)]
    }-${
      Math.floor(Math.random() * modelCodes.length) *
      Math.floor(Math.random() * modelCodes.length)
    }`;
    const region = regions[Math.floor(Math.random() * regions.length)];
    data.push({ modelCode, region });
  }

  return data;
};

// Generate 1000 items
const optionsOld = generateData(100);

const SearchableList = ({
  title = "Copy from another model",
  top = "100px",
  onSelectAction = (e) => {},
  options = [],
  intl = null,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilterData] = useState([]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    let d = options.filter((item) => {
      return (
        item.label?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item.secondaryLabel?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
    });
    setFilterData(d);
  }, [options, searchTerm]);

  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const divRef = useRef(null);

  useEffect(() => {
    window.copyOptionDropClose = () => setIsOpen(false);
  });

  const handleButtonClick = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
      setIsOpen(!isOpen);
    }
  };

  const handleClickOutside = (event) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target) &&
      !buttonRef.current.contains(event.target)
    ) {
      setSearchTerm("");
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div>
      <div
        id="basic-button"
        onClick={handleButtonClick}
        style={{
          display: "flex",
          lineHeight: "20px",
          width: "fit-content",
          marginLeft: "auto",
          cursor: "pointer",
        }}
        ref={buttonRef}
      >
        <Typography
          style={{ lineHeight: "30px", fontSize: "12px", fontWeight: "400" }}
        >
          {title}
        </Typography>{" "}
        <ArrowDropDownIcon />
      </div>

      {isOpen && (
        <div
          ref={divRef}
          style={{
            position: "absolute",
            top: `${position.top - 50}px`,
            right: `${20}px`,
            backgroundColor: "white",
            zIndex: 1000,
          }}
        >
          <div className="searchable-list-container">
            <input
              type="text"
              placeholder={title}
              value={searchTerm}
              onChange={handleSearch}
              className="search-input"
            />
            <ul className="model-list">
              {filteredData.map((item, index) => (
                <li
                  key={index}
                  className="list-item"
                  onClick={() => {
                    onSelectAction(item);
                    setIsOpen(false);
                  }}
                >
                  <span className="model-code">{injectIntlTranslation(intl, item.label, item.label)}</span>
                  <span className="region">{injectIntlTranslation(intl, item.secondaryLabel, item.secondaryLabel)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default injectIntl(SearchableList);
